document.addEventListener('DOMContentLoaded', function() {
  const sizePicker = document.querySelector('.size-picker');
  if (sizePicker) {
    const buttons = sizePicker.querySelectorAll('.size-option-button');
    
    buttons.forEach(button => {
      button.addEventListener('click', function() {
        const url = this.getAttribute('data-url');
        if (url) {
          window.location.href = url;
        }
      });
    });
  }
}); 